export default (state = {}, action) => {
  switch (action.type) {
    case "VERSIONS/PUSH": {
      const { newSnapshot } = action.payload;
      const { snapshots, currentIndex } = state;
      const currentSnapshot = snapshots[currentIndex];
      if(currentSnapshot === newSnapshot) return state;
      snapshots.splice(currentIndex + 1, snapshots.length - currentIndex);
      snapshots.push(newSnapshot);
      return {
        ...state,
        snapshots: snapshots,
        currentIndex: currentIndex + 1
      };
    }
    case "VERSIONS/UNDO": {
      const currentIndex = state.currentIndex - 1;
      return {...state, currentIndex: currentIndex};
    }
    case "VERSIONS/REDO": {
      const currentIndex = state.currentIndex + 1;
      return {...state, currentIndex: currentIndex};
    }
    default: {
      return state;
    }
  }
};
